import {
  TextInput,
  Grid,
  Stack,
  ScrollArea,
  Button,
  LoadingOverlay,
  CloseButton,
  Group,
} from "@mantine/core";
import React, { useEffect } from "react";
import { useMutation } from "@apollo/client";
import { showNotification } from "@mantine/notifications";
import { useForm } from "@mantine/form";
import { useViewportSize } from "@mantine/hooks";
import { CREATE_Value, Update_Value } from "apollo/mutuations";
import { GET_Values } from "apollo/queries";
import { customLoader } from "components/utilities/loader";

const EditValueModal = ({ setOpened, activePage, values }) => {
  const form = useForm({
    initialValues: {
      value: "",
    },
  });

  const { height } = useViewportSize();

  const [updateValue, { loading: addValues }] = useMutation(Update_Value);
  useEffect(() => {
    console.log(values);
    if (values) {
      form.setValues({
        value: values?.value,
      });
    }
  }, [values]);

  const submit = () => {
    updateValue({
      variables: {
        id: values.id,
        value: form.getInputProps("value").value,
      },
      onCompleted(data) {
        showNotification({
          color: "green",
          title: "Success",
          message: "Values Updated Successfully",
        });
        setOpened(false);
      },
      onError(error) {
        showNotification({
          color: "red",
          title: "Error",
          message:
            error?.graphQLErrors?.[0]?.message || "Failed to update value",
        });
      },
    });
  };

  return (
    <>
      <LoadingOverlay
        visible={addValues}
        color="blue"
        overlayBlur={2}
        loader={customLoader}
      />
      <ScrollArea style={{ height: height / 1.8 }} type="auto" offsetScrollbars>
        <form onSubmit={form.onSubmit(() => submit())}>
          <Stack>
            <Grid>
              <Grid.Col span={12}>
                <TextInput
                  required
                  label="Value"
                  placeholder="Enter a value and click Add"
                  {...form.getInputProps("value")}
                />
              </Grid.Col>

              <Grid.Col span={12}>
                <Button
                  style={{
                    width: "30%",
                    backgroundColor: "#FF6A00",
                    color: "#FFFFFF",
                  }}
                  fullWidth
                  type="submit"
                  color="blue"
                >
                  Submit
                </Button>
              </Grid.Col>
            </Grid>
          </Stack>
        </form>
      </ScrollArea>
    </>
  );
};

export default EditValueModal;
